export const displaySigninModal = (e) => {
  if (e) {
    e.preventDefault();
  }
  const modalEvent = document.createEvent('Event');
  modalEvent.initEvent('openSignInModal', true, true);
  window.dispatchEvent(modalEvent);
};
